module.exports = __webpack_public_path__ + "img/eccc63fabd8542e0a1e67d45ca11b977-1024.fbe1ea7a.jpg";